import { Button } from "@acdc2/ui/components/button";
import { Icon } from "@mdi/react";
import { mdiFileUploadOutline } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { DocumentUploadDialogContent } from "./DocumentUploadDialogContent";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";

export function DocumentUploadButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onOpenChange = (newIsOpen: boolean) => {
    setIsOpen(newIsOpen);
  };

  useEffect(() => {
    const onDragOver = (event: DragEvent) => {
      event.preventDefault();
      setIsOpen(true);
    };

    document.addEventListener("dragover", onDragOver);

    return () => {
      document.removeEventListener("dragover", onDragOver);
    };
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="documents-upload-button">
          <Icon path={mdiFileUploadOutline} size="1.25rem" />
          {t("DocumentUploadButton.label")}
        </Button>
      </DialogTrigger>
      <DocumentUploadDialogContent onDone={() => setIsOpen(false)} />
    </Dialog>
  );
}
